import React, { Fragment } from 'react'
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components'
import { GlobalStyles, theme } from '@ui-library/sl'

const GlobalAppStyles = createGlobalStyle`
  .sl-shield-container {
    position: absolute;
    z-index: 2147483647;
  }
`

const Background = styled.div`
  z-index: -1;
  position: absolute;
  background: #e30513;
  width: 100%;
  top: 44px;
  padding-top: 95%;

  @media (min-width: 769px) {
    top: 70px;
    padding-top: 35%;
  }
`

const Colors = {
  paleGreyLight: '#f5f7fa',
  silver: '#ccd1d9',
}

const NewTheme = { ...theme, Colors }

const Layout = ({ children, ...props }) => (
  <ThemeProvider theme={NewTheme}>
    <Fragment {...props}>
      <GlobalStyles />
      <GlobalAppStyles />
      <Background />
      {children}
    </Fragment>
  </ThemeProvider>
)

export default Layout
